var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "FormBox",
        { attrs: { title: "盈诺签服务公告" } },
        [
          _c(
            "div",
            {
              ref: "agreement",
              staticClass: "agreement",
              on: { scroll: _vm.scrollEvent }
            },
            [
              _vm._v("\n      公告编号：YNQ-2020-005"),
              _c("br"),
              _vm._v("\n      发布日期：2020年5月25日"),
              _c("br"),
              _c("br"),
              _vm._v("\n      尊敬的盈诺签用户："),
              _c("br"),
              _vm._v(
                "\n      为进一步提升服务质量、保障用户权益，现将平台功能优化及服务升级事项公告如下："
              ),
              _c("br"),
              _vm._v("\n\n      一、服务升级说明"),
              _c("br"),
              _vm._v("\n      合规性强化"),
              _c("br"),
              _vm._v(
                "\n      根据《中华人民共和国电子签名法》及最新行业规范，平台已完成权威CA机构认证升级，确保所有电子合同具备法律效力，支持司法存证调取。"
              ),
              _c("br"),
              _vm._v("\n\n      安全技术升级"),
              _c("br"),
              _vm._v(
                "\n\n      新增国密SM2/SM3算法加密，文件传输与存储安全性达金融级标准；"
              ),
              _c("br"),
              _vm._v(
                "\n\n      实名认证系统对接公安部公民网络身份识别eID系统，身份核验精准度提升至99.99%。"
              ),
              _c("br"),
              _vm._v("\n\n      多终端兼容"),
              _c("br"),
              _vm._v(
                '\n      全面支持PC网页端、iOS/Android移动端、微信小程序等多平台签约，实现"一键发起，全端同步"。'
              ),
              _c("br"),
              _vm._v("\n\n      二、新增功能上线"),
              _c("br"),
              _vm._v("\n      智能模板库"),
              _c("br"),
              _vm._v(
                "\n      提供1000+行业合同模板（含劳动协议、购销合同、租赁协议等），支持用户自定义模板及条款智能纠错。"
              ),
              _c("br"),
              _vm._v("\n\n      团队协作签批"),
              _c("br"),
              _vm._v(
                "\n      新增多角色会签功能，支持跨部门、跨企业多方在线协同签署，流程状态实时追踪。"
              ),
              _c("br"),
              _vm._v("\n\n      区块链存证服务"),
              _c("br"),
              _vm._v(
                "\n      签约文件自动同步至司法区块链节点，生成唯一存证编号，可一键出具《电子签约存证报告》。"
              ),
              _c("br"),
              _vm._v("\n\n      三、服务优化与用户权益"),
              _c("br"),
              _vm._v("\n      操作简化"),
              _c("br"),
              _vm._v(
                "\n\n      新增身份证OCR识别、企业工商信息自动填充功能，缩短发起流程50%；"
              ),
              _c("br"),
              _vm._v(
                "\n\n      短信/邮件提醒服务免费升级，关键节点自动推送提醒。"
              ),
              _c("br"),
              _vm._v("\n\n      售后服务承诺"),
              _c("br"),
              _vm._v("\n\n      7×12小时客服支持（热线：400-666-0717）；"),
              _c("br"),
              _vm._v(
                "\n\n      电子签章法律咨询免费通道（平台在线客服入口）。"
              ),
              _c("br"),
              _vm._v("\n\n      四、注意事项"),
              _c("br"),
              _vm._v("\n      请确保账号完成企业/个人实名认证后再发起签约；"),
              _c("br"),
              _vm._v("\n\n      合同签署前请仔细核对签署方信息及文件内容；"),
              _c("br"),
              _vm._v(
                "\n\n      建议下载合同至本地并同步使用平台存证服务，双重备份保障权益。"
              ),
              _c("br"),
              _vm._v("\n\n      五、联系我们"),
              _c("br"),
              _vm._v("\n      如有疑问，可通过以下方式咨询："),
              _c("br"),
              _vm._v("\n\n      客服热线：400-666-0717（工作日9:00-21:00）"),
              _c("br"),
              _vm._v('\n\n      在线咨询：登录官网点击右下角"在线客服"'),
              _c("br"),
              _vm._v("\n\n      帮助中心：https://www.yingnuoqian.com"),
              _c("br"),
              _vm._v(
                "\n\n      盈诺签将持续以技术赋能信任，感谢您的一路同行！"
              ),
              _c("br"),
              _c("br"),
              _vm._v("\n      盈诺签运营中心"),
              _c("br"),
              _vm._v("\n      2020年5月25日"),
              _c("br"),
              _vm._v("\n      （本公告最终解释权归盈诺签所有）"),
              _c("br"),
              _c("br"),
              _c("br")
            ]
          ),
          _c("div", { staticStyle: { height: "10px" } }),
          _c(
            "el-checkbox",
            {
              attrs: { disabled: _vm.checkboxDisabled },
              model: {
                value: _vm.checked,
                callback: function($$v) {
                  _vm.checked = $$v
                },
                expression: "checked"
              }
            },
            [_vm._v("我已阅读《盈诺签服务公告》\n    ")]
          ),
          _c("div", { staticStyle: { height: "10px" } }),
          _c(
            "div",
            [
              _c(
                "el-button",
                {
                  staticClass: "login-btn",
                  staticStyle: { width: "100%" },
                  attrs: { loading: _vm.loading, type: "primary" },
                  on: { click: _vm.submit }
                },
                [_vm._v("确认开通\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }